<!--eslint-disable-->
<template>
  <transition name="fade">
    <el-table
      v-loading="tableLoading"
      ref="table"
      :data="data"
      :max-height="height"
      :stripe="stripe"
      :highlight-current-row="highlightCurrentRow"
      :tree-props="treeProps"
      :border="border"
      :span-method="arraySpanMethod"
      :row-class-name="tableRowClassName"
      row-key="id"
      :key="tableKey"
      style="width: 100%; color: #666; font-size: 13px"
      @selection-change="handleSelectionChange"
      @select="handleSelect"
      @row-click="rowClick"
      @sort-change="sortChange"
      @row-dblclick="rowDblclick"
      @current-change="handleCurrentChange"
    >
      <el-table-column v-if="isDragTable" label="#" align="center" width="70">
        <template slot-scope="scope">
          <i class="el-icon-menu"></i>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selection"
        :resizable="false"
        :reserve-selection="reserveSelection"
        :selectable="selectable"
        fixed
        type="selection"
        align="center"
        width="55"
      />
      <el-table-column
        v-if="index"
        :resizable="false"
        label="序号"
        type="index"
        align="center"
        width="70"
      />
      <template v-for="(col, index) in columnsTitle">
        <el-table-column
          :resizable="false"
          :key="col.key"
          :show-overflow-tooltip="col.isTooltip"
          :prop="col.key"
          :fixed="col.fixed || null"
          :align="col.align || 'center'"
          :label="label(col)"
          :width="col.width || null"
          :min-width="col.minWidth || null"
          :render-header="col.renderHeader"
          :filters="col.searchFilters"
          :filter-method="col.filterMethod"
          :sortable="col.sortable"
          :sort-method="col.sortMethod"
          filter-placement="bottom"
        >
          <template slot-scope="scope">
            <render-column
              v-if="col.render || col.filters"
              :render-content="col.render"
              :scope="scope"
              :prop="col.key"
              :multiple="col.multiple"
              :filters="col.filters"
            />
            <span v-else>
              {{ scope.row[col.key] }}
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </transition>
</template>

<script>
/* eslint-disable */
import renderColumn from "./render-column";
import { mapGetters } from "vuex";
export default {
  components: { renderColumn },
  props: {
    isDragTable: { type: Boolean, default: false },
    selection: { type: Boolean, default: false },
    isTooltip: { type: Boolean, default: true },
    index: { type: Boolean, default: false },
    tableKey: { type: Number, default: 1 },
    data: { type: Array, required: true },
    columnsTitle: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    highlightCurrentRow: { type: Boolean, default: false },
    sortChange: { type: Function, default: function() {} },
    selectable: { type: Function, default: function() {
      return true
    } },
    arraySpanMethod: {
      type: Function,
      default: () => {
        return function() {
          return {
            rowspan: 0,
            colspan: 0
          };
        };
      }
    },
    border: { type: Boolean, default: false },
    stripe: { type: Boolean, default: false },
    height: { type: [String, Number], default: 200 },
    treeProps: { type: Object, default: function() {} },
    tableRowClassName: { type: [String, Function], default: null },
    reserveSelection: { type: Boolean, default: false }
  },
  data() {
    return {
      tableHeight: 0
    };
  },
  computed: {
    tableLoading() {
      return this.loading;
    }
  },
  mounted() {
    window.addEventListener("resize", this.doLayout);
  },
  updated() {
    this.$refs.table.doLayout(); // 重新布局table  解决table错误问题
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.doLayout);
  },
  methods: {
    label(col) {
      return col.title + (col.unit ? "(" + col.unit + ")" : "");
    },
    handleSelect(selection, row) {
      this.$emit("select", selection, row);
    },
    handleCurrentChange(currentRow, oldCurrentRow) {
      this.$emit("current-change", currentRow, oldCurrentRow);
    },
    handleSelectionChange(selection) {
      if (!this.selection) return;
      this.$emit("select-change", selection);
    },
    rowDblclick() {
      this.$emit("row-dblclick", ...arguments);
    },
    rowClick() {
      this.$emit("row-click", ...arguments);
    },
    doLayout() {
      this.$refs.table.doLayout(); // 重新布局table  解决table错误问题
    }
  },
  watch:{
    selection: {
      handler:()=>{
      },
      deep: true
    }
  }
};
</script>

<style>
.el-table {
  border: 1px solid #ebeef5;
}
body .el-table th.gutter {
  display: table-cell !important;
}

body .el-table colgroup.gutter {
  display: table-cell !important;
}
</style>
